import * as commsAPIs from './commsAPIs';
import * as catalogAPIs from './catalogAPIs';
import * as configAPIs from './configServiceAPI';
import * as proxyAPIs from './proxyAPIs';
import * as userAPIs from './userServiceAPI';
import * as lifelineAPIs from './lifelineServiceAPI';
import * as participantAPIs from './participantServiceAPI';
import * as gatewayAPIs from './gatewayServiceAPI';
import * as yonkoAPIs from './yonkoAPI';
import * as motifAPIs from './motifAPI';

export {
  commsAPIs,
  catalogAPIs,
  configAPIs,
  proxyAPIs,
  userAPIs,
  participantAPIs,
  lifelineAPIs,
  gatewayAPIs,
  yonkoAPIs,
  motifAPIs,
};
